<div class="color-bar"></div>

<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    
    <!-- Filtros -->
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">

            <!-- Filtros de Dealers -->
            <div class="filtro-dash">
              <div>
                <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                  fluxoLeads.dealers
                </div>
                <span class="btn btn-outline-info btn-sm" *ngFor="let dealer of filtroDealers.selecionados()"
                  style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerDealer(dealer)">
                  {{dealer.nome}}
                  <i class="fa fa-times" aria-hidden="true" (click)="removerDealer(dealer)"></i>
                </span>
                <div class="botao">
                  <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                    <em class="fa fa-plus"></em>
                  </button>
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <hr>

            <!-- Controles de Data -->
            <div class="row ptb20">
              <div class="col col-3">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  fluxoLeads.dataInicial
                </div>
                <p-calendar [(ngModel)]="data_inicial" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [yearNavigator]="true"
                  (onClearClick)="limpaDataInicial()" [monthNavigator]="true" yearRange="2000:2030"
                  placeholder="Selecione a data inicial"
                  showButtonBar="true" (onSelect)="onDataInicialChange()">
                </p-calendar>
              </div>
              <div class="col col-3">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  fluxoLeads.dataFinal
                </div>
                <p-calendar [(ngModel)]="data_final" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" (onClearClick)="limpaDataFinal()"
                  placeholder="Selecione a data final"
                  showButtonBar="true" [monthNavigator]="false" [yearNavigator]="false" yearRange="2000:2030"
                  [minDate]="getMinDateFinal()" [maxDate]="getMaxDateFinal()" (onSelect)="onDataFinalChange()">
                </p-calendar>
              </div>
              <div class="col col-lg-6 col-md-12 mt-3">
                <div class="d-flex align-items-end justify-content-start flex-wrap">
                  <button type="button" class="btn btn-primary mr-2 mb-2" (click)="aplicarFiltros()">
                    {{ 'fluxoLeads.filtrar' | translate }}
                    <i class="fas fa-search ml-1"></i>
                  </button>
                </div>
              </div>
            </div>
            <hr>

          </div>
        </div>
      </div>
    </div>

    <!-- Botões de Regionais -->
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">
            <div class="filtro-dash">
              <div>
                <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px; font-weight: bold;">
                  fluxoLeads.regionais
                </div>
                <div class="d-flex flex-wrap">
                  <button 
                    pButton 
                    type="button"
                    *ngFor="let regional of regionais; let i = index; trackBy: trackByRegionalId"
                    [class.p-button-primary]="isRegionalSelecionada(regional)"
                    [class.p-button-outlined]="!isRegionalSelecionada(regional)"
                    class="p-button-sm p-button-secondary mr-2 mb-2 d-flex justify-content-center align-items-center"
                    (click)="selecionarRegional(regional)"
                    style="text-transform: uppercase; min-width: 120px;">
                    {{ getNomeRegional(regional, i) }}
                  </button>
                  <button 
                    pButton 
                    type="button"
                    [class.p-button-primary]="isTotalSelecionado()"
                    [class.p-button-outlined]="!isTotalSelecionado()"
                    class="p-button-sm p-button-secondary mr-2 mb-2 d-flex justify-content-center align-items-center"
                    (click)="selecionarTotal()"
                    style="text-transform: uppercase; min-width: 120px;">
                    {{ 'fluxoLeads.total' | translate }}
                  </button>
                </div>
                <div class="clear"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Gráficos -->
    <div class="row mr-2 ml-2" *ngIf="regionalSelecionada || visualizandoTotal">
      <div class="col col-lg-6">
        <div class="grafico-card">
          <h5 translate class="text-center grafico-titulo">fluxoLeads.graficos.conversaoPorCategoria</h5>
          <!-- Loading Overlay -->
          <div class="loading-overlay" *ngIf="loadingGraficoPizza">
            <p-progressSpinner></p-progressSpinner>
            <label translate>fluxoLeads.carregandoGrafico</label>
          </div>
          <!-- Conteúdo do Gráfico de Pizza -->
          <div class="grafico-container" [class.loading-opacity]="loadingGraficoPizza">
            <p-chart *ngIf="graficoPizza" type="pie" [plugins]="plugins" [data]="graficoPizza" [options]="optionsPizza"></p-chart>
          </div>
        </div>
      </div>
      <div class="col col-lg-6">
        <div class="grafico-card">
          <h5 translate class="text-center grafico-titulo">fluxoLeads.graficos.funilConversao</h5>
          <!-- Loading Overlay -->
          <div class="loading-overlay" *ngIf="loadingGraficoFunil">
            <p-progressSpinner></p-progressSpinner>
            <label translate>fluxoLeads.carregandoGrafico</label>
          </div>
          <!-- Conteúdo do Gráfico de Funil -->
          <div class="grafico-container" [class.loading-opacity]="loadingGraficoFunil">
            <apx-chart *ngIf="chartOptionsFunil"
              [series]="chartOptionsFunil.series"
              [chart]="chartOptionsFunil.chart"
              [plotOptions]="chartOptionsFunil.plotOptions"
              [xaxis]="chartOptionsFunil.xaxis"
              [dataLabels]="chartOptionsFunil.dataLabels"
              [fill]="chartOptionsFunil.fill"
              [tooltip]="chartOptionsFunil.tooltip"
              [legend]="chartOptionsFunil.legend">
            </apx-chart>
          </div>
        </div>
      </div>
    </div>

    <!-- Grid de Fluxo de Leads -->
    <div class="row mr-2 ml-2" *ngIf="regionalSelecionada || visualizandoTotal">
      <div class="col col-lg-12">
        <div class="fluxo-leads-container">
          
          <!-- Cabeçalho da Regional -->
          <div class="fluxo-leads-header">
            <div class="header-title">
              <h5>{{ visualizandoTotal ? ('fluxoLeads.total' | translate) : (regionalSelecionada.descricao || regionalSelecionada.nome) }}</h5>
            </div>
          </div>

          <!-- Loading Overlay -->
          <div class="loading-overlay" *ngIf="loadingTabela">
            <p-progressSpinner></p-progressSpinner>
            <label translate>fluxoLeads.carregandoDados</label>
          </div>

          <!-- Tabela de Dados -->
          <div class="table-responsive" [class.loading-opacity]="loadingTabela">
            <table class="fluxo-leads-table" *ngIf="dadosFluxoLeads">
              <thead>
                <tr>
                  <th translate class="text-left">fluxoLeads.tabela.dealer</th>
                  <th class="text-center" *ngFor="let categoria of dadosFluxoLeads.categorias">
                    {{ categoria }}
                  </th>
                  <th translate class="text-center">fluxoLeads.tabela.total</th>
                  <th translate class="text-center">fluxoLeads.tabela.salesMTD</th>
                  <th translate class="text-center">fluxoLeads.tabela.crPercent</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let linha of dadosFluxoLeads.linhas; trackBy: trackByDealerId" class="data-row">
                  <td class="text-left dealer-cell">{{ linha.dealer }}</td>
                  <td class="text-center" *ngFor="let categoria of dadosFluxoLeads.categorias">
                    {{ getPercentualFormatado(linha.valores[categoria]) }}
                  </td>
                  <td class="text-center total-cell">{{ linha.total }}</td>
                  <td class="text-center">{{ linha.totalVendas || 0 }}</td>
                  <td class="text-center">{{ getPercentualFormatado(linha.crPct) }}</td>
                </tr>
                
                <!-- Linha de Total -->
                <tr class="total-row">
                  <td translate class="text-left total-label">fluxoLeads.tabela.total</td>
                  <td class="text-center" *ngFor="let categoria of dadosFluxoLeads.categorias">
                    {{ getPercentualFormatado(dadosFluxoLeads.total_regiao.valores[categoria]) }}
                  </td>
                  <td class="text-center total-cell">{{ dadosFluxoLeads.total_regiao.total }}</td>
                  <td class="text-center">{{ dadosFluxoLeads.total_regiao.totalVendas || 0 }}</td>
                  <td class="text-center">{{ getPercentualFormatado(dadosFluxoLeads.total_regiao.crPct)}}</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>

    <!-- Mensagem vazia -->
    <div class="row mr-2 ml-2" *ngIf="!loading && regionais.length === 0">
      <div class="col col-lg-12 text-center py-5">
        <p translate>fluxoLeads.nenhumaRegionalDisponivel</p>
      </div>
    </div>

  </div>
</div>

<!-- Componente modular para filtro de dealers -->
<app-filtro-dealers [(visible)]="displayFiltrosDealers" [dealers]="filtroDealers.dealers"
  [headerTitle]="'analiseGarantia.selecioneDealers'" [filterPlaceholder]="'analiseGarantia.filtrarDealers'"
  (dealerSelected)="onAdicionarDealerFiltro($event)">
</app-filtro-dealers>